import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import Megapark from "../../assets/images/megapark.png";

const Header: React.FC = () => {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  // Mobil menü görünürlüğü için state
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);
  // Mobil alt menü görünürlüğü için state
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);

  const handleMouseEnter = (dropdown: string) => {
    setActiveDropdown(dropdown);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  // Hamburger butonuna basıldığında menüyü aç/kapat
  const toggleMobileMenu = () => {
    setMobileOpen((prev) => !prev);
    if (!mobileOpen) {
      // menü açılırken önce alt menüleri kapalı başlat
      setOpenSubmenu(null);
    }
  };

  // Overlay tıklanınca menüyü kapat
  const closeMobileMenu = () => {
    setMobileOpen(false);
    setOpenSubmenu(null);
  };

  // Mobilde alt menü aç/kapat
  const toggleSubmenu = (key: string) => {
    setOpenSubmenu((prev) => (prev === key ? null : key));
  };

  return (
    <header className="site-header">
      {/* Logo ve menü alanı */}
      <Container className="py-2">
        <div className="d-flex justify-content-between align-items-center">
          {/* Logo */}
          <Link to="/" className="logo">
            <img
              src={Megapark}
              alt="Megapark Hastnaesi"
              height={42}
            />
          </Link>

          {/* Ana Navigasyon */}
          <nav className="main-nav d-none d-lg-block">
            <ul className="nav-links">
              <li>
                <Link to="/">Anasayfa</Link>
              </li>
              <li className="has-dropdown">
                <Link to="">Kurumsal</Link>
                <div className="dropdown-menu">
                  <Link to="/bashekim-mesaji">Başhekim Mesajı</Link>
                  <Link to="/hakkimizda">Hakkımızda</Link>
                  <Link to="/vizyon-misyon">Vizyon & Misyon</Link>
                  <Link to="/is-basvurusu">İş Başvurusu</Link>
                  <Link to="/hastane-refakatci">Hastane Refakatçi ve Ziyaretçi</Link>
                </div>
              </li>
              <li>
                <Link to="/tibbi-birimler">Tıbbi Birimler</Link>
              </li>
              <li>
                <Link to="/hekimler">Hekimler</Link>
              </li>
              <li className="has-dropdown">
                <Link to="">Kalite Yönetimi</Link>
                <div className="dropdown-menu">
                  <Link to="/organizasyon-semasi">Organizasyon Şeması</Link>
                </div>
              </li>
              <li>
                <Link to="/anlasmali-sigortalar">Anlaşmalı Sigortalar</Link>
              </li>
              <li>
                <Link to="/tup-bebek">Tüp Bebek</Link>
              </li>
              <li>
                <Link to="/iletisim">İletişim</Link>
              </li>
            </ul>
          </nav>

          {/* Sosyal Medya İkonları */}
          <div className="social-icons d-none d-lg-flex">
            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/" className="social-icon">
              <i className="bi bi-facebook"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/" className="social-icon">
              <i className="bi bi-twitter"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/megaparkhastanesi/reels/" className="social-icon">
              <i className="bi bi-instagram"></i>
            </a>
            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/" className="social-icon">
              <i className="bi bi-linkedin"></i>
            </a>
          </div>


          {/* Mobile menü butonu */}
          <button
            className="navbar-toggler d-lg-none"
            type="button"
            aria-label="Menüyü aç/kapat"
            aria-expanded={mobileOpen}
            aria-controls="mobileMenu"
            onClick={toggleMobileMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
      </Container>

      {/* Overlay (arka plan) */}
      <div
        className={`mobile-overlay d-lg-none ${mobileOpen ? "active" : ""}`}
        onClick={closeMobileMenu}
        aria-hidden={!mobileOpen}
      />

      {/* Mobil Menü */}
      <div
        id="mobileMenu"
        className={`mobile-menu d-lg-none ${mobileOpen ? "active" : ""}`}
        aria-hidden={!mobileOpen}
      >
        <Container>
          <ul className="nav-mobile">
            <li><Link to="/">Anasayfa</Link></li>

            {/* Kurumsal - alt menülü */}
            <li className={`has-sub ${openSubmenu === "kurumsal" ? "open" : ""}`}>
              <button
                type="button"
                className="sub-toggle"
                aria-expanded={openSubmenu === "kurumsal"}
                onClick={() => toggleSubmenu("kurumsal")}
              >
                Kurumsal
                <i className={`bi ${openSubmenu === "kurumsal" ? "bi-chevron-up" : "bi-chevron-down"}`} aria-hidden />
              </button>
              <ul className="sub-list">
                <li><Link to="/hakkimizda" onClick={closeMobileMenu}>Hakkımızda</Link></li>
                <li><Link to="/vizyon-misyon" onClick={closeMobileMenu}>Vizyon & Misyon</Link></li>
                <li><Link to="/bashekim-mesaji" onClick={closeMobileMenu}>Başhekim Mesajı</Link></li>
                <li><Link to="/is-basvurusu" onClick={closeMobileMenu}>İş Başvurusu</Link></li>
                <li><Link to="/hastane-refakatci" onClick={closeMobileMenu}>Hastane Refakatçi ve Ziyaretçi</Link></li>
              </ul>
            </li>

            <li><Link to="/tibbi-birimler" onClick={closeMobileMenu}>Tıbbi Birimler</Link></li>
            <li><Link to="/hekimler" onClick={closeMobileMenu}>Hekimler</Link></li>

            {/* Kalite Yönetimi - alt menülü */}
            <li className={`has-sub ${openSubmenu === "kalite" ? "open" : ""}`}>
              <button
                type="button"
                className="sub-toggle"
                aria-expanded={openSubmenu === "kalite"}
                onClick={() => toggleSubmenu("kalite")}
              >
                Kalite Yönetimi
                <i className={`bi ${openSubmenu === "kalite" ? "bi-chevron-up" : "bi-chevron-down"}`} aria-hidden />
              </button>
              <ul className="sub-list">
                <li><Link to="/organizasyon-semasi" onClick={closeMobileMenu}>Organizasyon Şeması</Link></li>
              </ul>
            </li>

            <li><Link to="/anlasmali-sigortalar" onClick={closeMobileMenu}>Anlaşmalı Sigortalar</Link></li>
            <li><Link to="/tup-bebek" onClick={closeMobileMenu}>Tüp Bebek</Link></li>
            <li><Link to="/iletisim" onClick={closeMobileMenu}>İletişim</Link></li>
          </ul>
        </Container>
      </div>
    </header>
  );
};

export default Header;
